//Custom components
import StatCard from '../../../UI/Card/StatCard';

const HousingUnitsCreatedWidget = ({ count }: { count: number }) => {
  return <StatCard title='Housing Units Created' stat={count} />;
};

export default HousingUnitsCreatedWidget;
